module.exports = __webpack_public_path__ + "static/img/logo.5eed71fa.png";